import React from "react"
import classes from "./ProductLineItem.module.css"
import { CustomBox } from "../../../spacings/CustomBox"
import { SanityImg } from "../../../../cms/components"
import { Product, ProductVariant } from "../../../../types/product"
import ProductLabel from "../../../molecules/Product/ProductLabel"
import ProductPrice from "../../../molecules/Product/ProductPrice"
import Square from "../../../shapes/Square"
import Link from "next/link"
import { productPagePath } from "../../../../root/routing/urls"
import ProductBadges from "../ProductBadges"
import ExtraDiscountBadges from "../ExtraDiscountBadges"

export interface ProductItemPrice {
  discountedPrice?: number
  originalPrice: number
  compareAtPrice?: number
  discountPercent?: number
  extraDiscountPercent?: number
}

export interface ProductGridItemProps {
  product: Product
  variant: ProductVariant
  pricing: ProductItemPrice
  topControls?: React.ReactNode
  children?: any
  bottomControls?: React.ReactNode
  priceBottomContents?: React.ReactNode
}

const ProductLineItem = ({
  product,
  variant,
  pricing,
  topControls,
  children,
  bottomControls,
  priceBottomContents,
}: ProductGridItemProps) => {
  return (
    <CustomBox flex="row" alignItems="flex-start" className={classes.imgBox}>
      <div className={classes.imgPromo}>
        <ProductBadges
          new={product.characteristics?.new}
          pricing={{
            discountPercent:
              pricing.discountPercent ??
              variant.inventory?.discountPercent ??
              0,
          }}
          promoLogoUrl={product.extraData?.promotions?.[0]?.logoUrl}
          promoLogoUrlWidth={60}
          height={16}
          noPromo={product.extraData?.noPromo}
          badgeClassName="mr-2"
        />
        <ExtraDiscountBadges
          extraDiscountPercent={pricing.extraDiscountPercent}
          height={16}
        />
        {/* {product.extraData?.noPromo && <div>NO PROMO</div>} */}
      </div>
      <CustomBox minWidth="22%" flexBasis="22%" pt={1} pb={1}>
        <Link
          href={productPagePath(variant.info.slug ?? product.info.slug)}
          passHref
        >
          <a>
            <Square center>
              <SanityImg asset={variant.media.productImages?.[0].asset} fluid />
            </Square>
          </a>
        </Link>
      </CustomBox>

      <CustomBox flexFill pl={1} maxWidth="78%">
        <div>
          <CustomBox
            flex="row"
            justifyContent="space-between"
            alignItems="flex-start"
            w100
          >
            <div className="mt-1" style={{ maxWidth: "90%" }}>
              <ProductLabel
                title={product.metadata.brand?.name}
                subtitle={variant.contents?.name?.toLowerCase()}
                classes={{
                  title: classes.title,
                  subtitle: classes.subtitle,
                }}
              />
            </div>
            <div className="text-right">{topControls}</div>
          </CustomBox>
        </div>
        <div>{children}</div>
        <CustomBox flex="row" justifyContent="space-between" mt={2}>
          <div className="mr-6">{bottomControls}</div>
          <div className="flex items-end pr-1 sm:pr-0">
            {pricing.originalPrice > 0 && (
              <ProductPrice
                layout="vertical"
                price={pricing.discountedPrice ?? pricing.originalPrice}
                compareAtPrice={pricing.compareAtPrice ?? pricing.originalPrice}
                className={classes.priceLabel}
              />
            )}
          </div>
        </CustomBox>
        {priceBottomContents}
      </CustomBox>
    </CustomBox>
  )
}

export default ProductLineItem
